import { Suspense } from "react";
import { LatLngLiteral } from "leaflet";
import { ErrorBoundary } from "react-error-boundary";

import { useMapPositionBounds } from "../../hooks/mapHooks";
import { Layer } from "../../types";
import { SelectedLayerDefaultGeometry } from "./SelectedLayerDefaultGeometry";
import { SelectedLayerFlandersGeometry } from "./SelectedLayerFlandersGeometry";

interface Props {
  layer: Layer;
  point: LatLngLiteral;
}

export function SelectedLayerGeometry(props: Props) {
  const { layer, point } = props;

  const bounds = useMapPositionBounds(point || { lat: 0, lng: 0 });

  return (
    <>
      {layer.sourceType !== "INFORMATIE_VLAANDEREN" && (
        <ErrorBoundary fallbackRender={() => null}>
          <Suspense fallback={null}>
            <SelectedLayerDefaultGeometry
              layer={layer}
              mapPosition={{
                ...bounds,
                position: point || { lat: 0, lng: 0 },
              }}
            />
          </Suspense>
        </ErrorBoundary>
      )}
      {layer.sourceType === "INFORMATIE_VLAANDEREN" && (
        <ErrorBoundary fallbackRender={() => null}>
          <Suspense fallback={null}>
            <SelectedLayerFlandersGeometry
              layer={layer}
              mapPosition={{
                ...bounds,
                position: point || { lat: 0, lng: 0 },
              }}
            />
          </Suspense>
        </ErrorBoundary>
      )}
    </>
  );
}
